import { Box, Button, Paper } from '@mui/material';
import styled from 'styled-components';

export const PageContainer = styled(Box)`
  padding: 32px;
  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const HeaderBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;
  }
`;

export const PaperWrapper = styled(Paper)`
  padding: 24px;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (max-width: 600px) {
    padding: 16px;
    margin-bottom: 16px;
  }
`;

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})`
  margin-top: 16px !important;
`;
